import { WifiOff } from "lucide-react";
import { useEffect, useState } from "react";

export function ConnectionBanner() {
  const [connected, setConnected] = useState(() => navigator.onLine);

  useEffect(() => {
    const online = () => setConnected(true);
    const offline = () => setConnected(false);
    const nativeStatus = (event: Event) =>
      setConnected((event as CustomEvent<boolean>).detail);
    window.addEventListener("online", online);
    window.addEventListener("offline", offline);
    window.addEventListener("restlab:network", nativeStatus);
    return () => {
      window.removeEventListener("online", online);
      window.removeEventListener("offline", offline);
      window.removeEventListener("restlab:network", nativeStatus);
    };
  }, []);

  if (connected) return null;
  return (
    <div className="connection-banner" role="status">
      <WifiOff /> Sin conexión. Las acciones que requieren sincronización están
      temporalmente no disponibles.
    </div>
  );
}
